import { render, staticRenderFns } from "./index_city_com.vue?vue&type=template&id=b12d464a&scoped=true"
import script from "./index_city_com.vue?vue&type=script&lang=js"
export * from "./index_city_com.vue?vue&type=script&lang=js"
import style0 from "./index_city_com.vue?vue&type=style&index=0&id=b12d464a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12d464a",
  null
  
)

export default component.exports